<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:12:00
 * @LastEditTime: 2025-09-27 21:36:18
-->
<template>
    <div class="tool">
      <main>
        <listPost type="myCollect"></listPost>
      </main>

      <van-tabbar v-model="active">
        <van-tabbar-item icon="orders-o" @click="toUrl('/servicePost')">岗位筛选</van-tabbar-item
        >
        <van-tabbar-item icon="apps-o" @click="toUrl('/serviceIntelligencePost')">智能匹配</van-tabbar-item
        >
        <van-tabbar-item icon="manager-o"
          >我的收藏</van-tabbar-item
        >
      </van-tabbar>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import listPost from "@/views/servicePost/component/listPost.vue"
  import { Image as VanImage } from 'vant'
  import axios from 'axios'
  Vue.use(VanImage)
  import { Tabbar, TabbarItem } from 'vant'
  Vue.use(Tabbar)
  Vue.use(TabbarItem)
  import { Toast } from 'vant'
  import { companyList, getDictType } from '@/api/xicaiquan'
  export default {
    name: 'serviceIntelligencePost',
    data () {
      return {
        active: 2,
        icon: {
          active: 'https://img01.yzcdn.cn/vant/user-active.png',
          inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png'
        },
        notices: [],
        queryParams: {
          current: 1,
          size: 10,
          companyName: ''
        },
        listData: [],
        companyMoldList: [],
        companyScaleList: [],
        companyTypeList: []
      }
    },
    created () {
      // Promise.all([
      //   this.getDictType('company_mold', 'companyMoldList'),
      //   this.getDictType('company_scale', 'companyScaleList'),
      //   this.getDictType('company_company_type', 'companyTypeList')
      // ]).then(res => {
      //   this.getData()
      // })

      if (!sessionStorage.getItem("service_phone")) {
        this.$router.replace({ path: '/servicePost' })
      }

    },
    components: {
      listPost
    },
    watch: {},
    methods: {
      
      getPostStatus (target, prop, row) {
        const item = this[target].find(item => item.value == row[prop])
  
        if (item) {
          return item.text
        } else {
          return '无'
        }
      },
      async getDictType (type, target, callback) {
        return new Promise(async (resolve, reject) => {
          const res = await getDictType(type)
          if (res.code == 200) {
            resolve()
            res.data.forEach(item => {
              this[target].push({
                text: item.dictLabel,
                value: item.dictValue
              })
            })
          } else {
            reject()
          }
        })
      },
      handleTips() {
        Toast('请联系班主任更改信息')
      },
      toUrl (path) {
        if (!path) {
          Toast('功能开发中')
          return
        }
  
        this.$router.replace({ path })
      }
    }
  }
  </script>
  <style scoped lang="scss">
  
  .van-tabbar {
    width: 100vw;
  }
  .text {
    width: 100%;
    background-color: white;
    font-size: 20px;
    // line-height: 40px;
    font-weight: bold;
    padding: 16px 10px;
    padding-top: 18px;
    margin-bottom: 30px;
    // padding-bottom: 200px;
  }
  .min_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 5px;
    padding-top: 18px;
    background-color: white;
    .min_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      justify-items: center;
    }
  }
  
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    font-size: 40px;
  }
  
  .tool {
    width: 100%;
    height: 100vh;
    background: #f3f6f9;
  
    .content {
      width: 95%;
      height: 300px;
      border-radius: 10px;
      background: #fff;
      margin: 30px auto;
  
      ul {
        display: flex;
  
        li {
          width: 80px;
          height: 50px;
          // box-shadow: 0px 0px 0px 1px #ddd;
          text-align: center;
          // line-height: 50px;
          margin-right: 10px;
          margin-top: 50px;
        }
      }
    }
  }

  .title-block {
    height: 60px;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    background: #fff;
    z-index: 100;
    padding: 10px;
  }
  
  
  </style>
  